import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import * as fromChat from './features/chat.reducer';
import { EffectsModule } from '@ngrx/effects';
import { IconModule } from 'app/icon/icon.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResizableModule } from 'angular-resizable-element';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';


import { ChatEffects } from './features/chat.effects';
import { CoreModule } from 'app/core/core.module';
import { ChatComponent } from './components/chat/chat.component';
import { ChatButtonComponent } from './components/chat-button/chat-button.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';

import { MessageTimerPipe } from './pipes/message-timer.pipe';

@NgModule({
  declarations: [
    ChatComponent,
    ChatButtonComponent,
    ChatMessageComponent,
    MessageTimerPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromChat.chatFeatureKey, fromChat.reducer),
    EffectsModule.forFeature([ChatEffects]),
    CoreModule,
    IconModule,
    NgScrollbarModule,
    CdkScrollableModule,
    ScrollingModule,
    DragDropModule,
    ResizableModule,
    MdbPopoverModule
  ],
  exports: [ChatComponent, ChatButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChatModule {
  constructor(injector: Injector) {
  }
}
